import { swRequest } from "@sourcewhale/core";

export const extensionCallbacks = (body) =>
  swRequest({
    path: "/api/extension/callbacks",
    method: "POST",
    body,
  });
